import React from 'react';
import { PageStyle } from '../Utils/generalStyles';

// Components
import NewsletterSection from '../Components/Newsletter';
import FooterSection from '../Components/Footer';

const ManageWaitlistPage = () => (
  <PageStyle>
    <NewsletterSection />
    <FooterSection />
  </PageStyle>
);

export default ManageWaitlistPage;
